import React from 'react'

/**
 * Secondary left rail schema by `activeKey` from primary nav (`getPrimaryKeyFromPath`).
 *
 * Section `type` values rendered in `SecondaryLeftNavigation/index.jsx`:
 * - `boardsPreview` | `boardsLanding` — BoardsSection; data: navigationData adapters
 * - `appsPreview` | `appsLanding` — AppsSection; data: `topApps` / `allApps` on section ctx
 * - `homePrimaryActions` — New Chat, Documents, and DO Voice grouped actions
 * - `newChatAction` — ActionButtonRow
 * - `documentsAction` — ActionButtonRow (navigates to Documents page)
 * - `doVoiceAction` — ActionButtonRow (navigates to DO Voice page)
 * - `buildAction` — ActionButtonRow under Build (navigates to Build page)
 * - `navAction` — ActionButtonRow with trailing chevron (optional thread deep link)
 * - `homeNavRail` — Pinned / Chats sections (home chat)
 * - `homeCodePrimaryActions` — New Project (DO Code)
 * - `homeCodeNavRail` — Pinned Project / Project List (DO Code)
 * - `searchRow` — SearchRow (home)
 * - `divider` | `placeholder` — layout / fallback
 */

export const SECONDARY_VIEW_KEYS = {
  HOME_MAIN: 'home-main',
  HOME_BOARDS_ALL: 'home-boards-all',
}

export const HOME_PRODUCT_KEYS = {
  CHAT: 'chat',
  VOICE: 'voice',
  CODE: 'code',
}
